import React from 'react';

import LegalNoticesDialog from 'sharedreact/components/LegalNoticesDialog';
import { translate } from 'sharedreact/utils/LanguageSupport';
import Dialog from 'sharedreact/components/Dialog';

type Props = {
  title: string,
  show: boolean,
  language: string,
  legalNotices: string
  
  onClose: () => void,
};

type State = {
  showLegalNotices: boolean,
};

class AboutDialog extends React.PureComponent<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      showLegalNotices: false
    };

    this.handleShowLegalNotices = this.handleShowLegalNotices.bind(this);
    this.handleCloseLegalNotices = this.handleCloseLegalNotices.bind(this);
  }

  handleShowLegalNotices (): void {
    this.setState({showLegalNotices: true});
  }

  handleCloseLegalNotices (): void {
    this.setState({showLegalNotices: false});
  }

  override render (): React.ReactNode {
    const { show, title, onClose, language, legalNotices } = this.props;

    const versionParts: string[] = title.split(' ');
    const copyrightYear: string = versionParts[versionParts.length - 1];

    return (
      <>
        <Dialog
          id='ae_dialog_about'
          show={show}
          onClose={onClose}
          title={''}
          language={language}
          className='esko_aboutwindow'
          noHeader
          noFooter
        >
          <div>
            <button
              id='ae_button_about_close_x'
              type='button'
              className='esko_close esko_about_close'
              onClick={onClose}>&times;</button>
            <div className='esko_aboutversiontext'>
              {title}
            </div>
            <div className='esko_abouttext'>
              {translate('shared.aboutdialog.copyrightText', copyrightYear)}
            </div>
            <div className='esko_legalnoticesbutton'>
              <button
                id='ae_button_about_legalnotices'
                type='button'
                className='esko_btn esko_btn-default'
                onClick={this.handleShowLegalNotices}>
                  {translate('shared.legalnotices.title')}
              </button>
            </div>
          </div>
        </Dialog>
        <LegalNoticesDialog show={this.state.showLegalNotices}
          language={language}
          legalNotices={legalNotices}
          onClose={this.handleCloseLegalNotices}
        />
      </>
    );
  }
}

export default AboutDialog;
